(function () {
  var doc = document.documentElement;
  doc.classList.add('js');

  // Révélation au défilement
  var items = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(sibs, 6) * 70 + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  // En-tête au défilement
  var header = document.querySelector('[data-header]');
  var onScroll = function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Menu mobile
  var burger = document.querySelector('[data-burger]');
  var nav = document.getElementById('vd-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      burger.setAttribute('aria-label', open ? 'Ouvrir le menu' : 'Fermer le menu');
      nav.classList.toggle('is-open', !open);
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Ouvrir le menu');
        nav.classList.remove('is-open');
      }
    });
  }

  // Bouton fixe mobile : visible après le haut de page, masqué sur la section rendez-vous
  var sticky = document.querySelector('[data-sticky]');
  var rdv = document.getElementById('rdv');
  var rdvVisible = false;
  if (sticky && rdv && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { rdvVisible = e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(rdv);
  }
  function update() { if (sticky) sticky.classList.toggle('is-on', window.scrollY > 600 && !rdvVisible); }
  window.addEventListener('scroll', update, { passive: true });
  update();

  // Onglets agenda / être rappelé
  var tabs = document.querySelectorAll('.vd-tabs [role=tab]');
  function showTab(name, focus) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-tab') === name;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
      if (on && focus) t.focus();
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tab]');
    if (b) showTab(b.getAttribute('data-tab'), b.getAttribute('role') !== 'tab');
  });
  var tablist = document.querySelector('.vd-tabs');
  if (tablist) tablist.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var cur = tablist.querySelector('[aria-selected=true]');
    var list = Array.prototype.slice.call(tabs);
    var i = list.indexOf(cur) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = list[(i + list.length) % list.length];
    showTab(next.getAttribute('data-tab'), true);
  });
  if (location.hash === '#etre-rappele') showTab('rappel', false);

  // Formulaire « Être rappelé » -> Make -> Airtable
  var form = document.querySelector('[data-lead-form]');
  if (form) {
    var msg = form.querySelector('.vd-form-real__msg');
    var ok = form.parentNode.querySelector('.vd-form-real__ok');
    var started = Date.now();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.textContent = '';
      form.querySelectorAll('[aria-invalid]').forEach(function (f) { f.removeAttribute('aria-invalid'); });
      var bad = [];
      form.querySelectorAll('[required]').forEach(function (f) { if (!f.value.trim()) bad.push(f); });
      var em = form.elements.email, tel = form.elements.telephone;
      if (em.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) bad.push(em);
      if (tel.value && tel.value.replace(/\D/g, '').length < 9) bad.push(tel);
      if (bad.length) {
        bad.forEach(function (f) { f.setAttribute('aria-invalid', 'true'); });
        msg.textContent = 'Merci de compléter les champs indiqués (nom, entreprise, secteur, téléphone et e-mail valides).';
        bad[0].focus();
        return;
      }
      if (form.elements.website.value || Date.now() - started < 2500) { // robot probable
        form.hidden = true; ok.hidden = false; return;
      }
      var btn = form.querySelector('[type=submit]');
      btn.disabled = true; btn.textContent = 'Envoi en cours…';
      var data = new URLSearchParams(new FormData(form));
      data.append('page', location.href.split('#')[0]);
      fetch(form.getAttribute('action'), { method: 'POST', body: data })
        .then(function (r) { if (!r.ok) throw new Error(r.status); })
        .then(function () {
          form.hidden = true; ok.hidden = false; ok.focus();
          try { if (window.fbq) window.fbq('track', 'Lead'); } catch (err) {}
          try { if (window.gtag) window.gtag('event', 'generate_lead'); } catch (err) {}
        })
        .catch(function () {
          btn.disabled = false; btn.innerHTML = 'Être rappelé <span aria-hidden="true">→</span>';
          msg.innerHTML = 'Oups, l\'envoi n\'a pas fonctionné. Réessayez ou écrivez-moi à <a href="mailto:visuedia@gmail.com">visuedia@gmail.com</a>.';
        });
    });
  }

  // Suivi des intentions de rendez-vous (Meta Pixel / Google) si installés
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-book],[data-book-open]');
    if (!a) return;
    var ev = a.hasAttribute('data-book-open') ? 'Schedule' : 'Contact';
    try { if (window.fbq) window.fbq('track', ev); } catch (err) {}
    try { if (window.gtag) window.gtag('event', ev === 'Schedule' ? 'ouvrir_agenda' : 'clic_rendez_vous'); } catch (err) {}
  });
})();
